import React, { useState, useEffect } from "react";
import { Typography, Button, Select, Spin } from "antd";
import StorePreviewCore from "./StorePreviewCore";

const { Title } = Typography;
const { Option } = Select;

// This component is used specifically in StoreDetail (view/status update only page)
const StorePreview = ({ 
  storeData, 
  status, 
  vendorDetails, 
  onUpdateStatus, 
  isLoading,
  editable = false 
}) => {
  const [storeStatus, setStoreStatus] = useState(status || "");

  useEffect(() => {
    setStoreStatus(status);
  }, [status]);

  const handleStatusUpdate = () => {
    if (onUpdateStatus) {
      onUpdateStatus(storeStatus);
    }
  };

  if (!storeData && !isLoading) {
    return <div>No store data available</div>;
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[40vh]">
        <Spin size="large" className="flex justify-center" />
      </div>
    );
  }

  return (
    <div className="bg-gray-100 p-4 rounded-lg shadow-md">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <Title level={4}>Store Details</Title>
        </div>

        {/* Only show status dropdown in StoreDetail page */}
        {editable && (
          <div>
            <Select
              size="middle"
              value={storeStatus}
              onChange={(e) => setStoreStatus(e)}
            >
              <Option value="Active">Active</Option>
              <Option value="Inactive">Inactive</Option>
            </Select>
          </div>
        )}
      </div>

      {/* Use the core component for the content */}
      <StorePreviewCore 
        storeData={storeData}
        vendorDetails={vendorDetails}
      />

      {/* Only show the update button in StoreDetail page */}
      {editable && (
        <Button
          onClick={handleStatusUpdate}
          htmlType="submit"
          loading={isLoading}
          type="primary"
          size="middle"
          className="w-full md:w-48 mt-2"
          disabled={isLoading}
        >
          Update Store Status
        </Button>
      )}
    </div>
  );
};

export default StorePreview;